@if (currentUser$ | async; as user) {
  <main class="wrapper">
    @if (displayCalendarConnectBanner(user)) {
      <app-banner [message]="'SETTINGS.CALENDAR_CONNECT_BANNER_MESSAGE' | translate"></app-banner>
    }
    <div class="main-content-container">
      <app-side-menu [user]="user"></app-side-menu>
      <div class="content-container" [class.add-float-offset]="sideMenuComponent?.isFloating ?? false">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
}
<app-search-bar></app-search-bar>
